
import Vue from "vue";
import {App, getAppSelectItems} from "@/utils/apps";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	props: {
		label: String,
		value: String as ()=>App,
		fancy: Boolean,
		disabled: Boolean,
		items: {
			type: Array as ()=>ISelectItem<App>[],
			default: ()=>{
				return getAppSelectItems();
			}
		}
	},
	methods: {
		onInput(value:App){
			this.$emit("input", value);
		}
	}
});
